import React from 'react';

const FormInput = ({ 
  id, 
  label, 
  type = 'text', 
  placeholder, 
  value, 
  onChange, 
  error,
  required = false,
  icon = null,
  name,
  disabled = false,
  size = 'medium'
}) => {
  const sizes = {
    small: 'px-3 py-2 text-sm',
    medium: 'px-4 py-2.5 text-sm',
    large: 'px-4 py-3 text-base'
  };

  return (
    <div className="space-y-1">
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-700">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative">
        <input
          id={id}
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={`w-full ${sizes[size]} border rounded-xl font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:bg-gray-50 disabled:text-gray-500 ${
            error 
              ? 'border-red-300 bg-red-50 focus:border-red-500 focus:ring-red-500' 
              : 'border-gray-300 bg-white hover:border-gray-400 focus:border-blue-500 focus:ring-blue-500'
          } ${icon ? 'pl-10' : ''}`}
          required={required}
        />
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <i className={`${icon} text-gray-400 text-lg`}></i>
          </div>
        )}
      </div>
      {error && <p className="text-sm font-medium text-red-600">{error}</p>}
    </div>
  );
};

export default FormInput;
